import { render } from "./field_tabs.vue?vue&type=template&id=75546a31&scoped=true"
import script from "./field_tabs.vue?vue&type=script&lang=js"
export * from "./field_tabs.vue?vue&type=script&lang=js"

import "./field_tabs.vue?vue&type=style&index=0&id=75546a31&scoped=true&lang=css"

import exportComponent from "/home/runner/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75546a31"],['__file',"app/javascript/submission_form/field_tabs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "75546a31"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('75546a31', __exports__)) {
    api.reload('75546a31', __exports__)
  }
  
  module.hot.accept("./field_tabs.vue?vue&type=template&id=75546a31&scoped=true", () => {
    api.rerender('75546a31', render)
  })

}


export default __exports__